import { Err, Res, ResponseData } from 'types';

import { http } from '.';

export type RegisterUserResponse = Res<Date>;
export type PartnerAddResponse = Res<Date>;
export type ManagerAddResponse = Res<Date>;
export type JobNumberAddResponse = Res<Date>;
export type CustomerNameAddResponse = Res<Date>;

export type LoginUserResponse = Res<ResponseData<string>>;
export type ActivateUserResponse = Res<ResponseData<true>>;

export const registerUser = async (body) =>
  await http.post<Err, RegisterUserResponse>('/UsersMi/register', body);

export const sendActivationAgain = async (body) =>
  await http.post<Err, RegisterUserResponse>(
    '/UsersMi/sendActivationLinkAgain',
    body
  );

export const activateUser = async (token: string) =>
  await http.post<Err, ActivateUserResponse>('/UsersMi/Activate', token);

export const loginUser = async (body) =>
  await http.post<Err, LoginUserResponse>('/UsersMi/authenticate', body);

export const logoutUser = async () => {
  await http.post<Err, any>('UsersMi/logOut');
};

export const retryUserActivation = async (body) =>
  await http.post<Err, any>('/UserMi/retry-activation', body);

export const passwordResetLink = async (body) =>
  await http.post<Err, any>('UsersMi/password/reset/link', body);

export const passwordReset = async (body) =>
  await http.post<Err, any>('UsersMi/password/reset', body);

export const passwordResetSublogin = async (data: {
  token: string;
  password: string;
  confirmPassword: string;
}) => await http.post<Err, any>('UsersMi/subUser/SubUserSetPassword', data);

export const addNewAccount = async (body) =>
  await http.post<Err, any>('/Account/new', body);

export const updatePassword = async (body) =>
  await http.post<Err, any>('UsersMi/password/change', body);

export const contactUs = async (body) =>
  await http.post<Err, any>('/UsersMi/ContactUs', body);

export const partnerAdd = async (body) =>
  await http.post<Err, PartnerAddResponse>('/Partner/add', body);
export const managerAdd = async (body) =>
  await http.post<Err, ManagerAddResponse>('/Manager/create', body);
export const jobNumberAdd = async (body) =>
  await http.post<Err, JobNumberAddResponse>('/InvoiceJob/create', body);
export const customerNameAdd = async (body) =>
  await http.post<Err, CustomerNameAddResponse>('/Customer/create', body);
